import { render } from "./ClassicButton.vue?vue&type=template&id=f124aaac&scoped=true"
import script from "./ClassicButton.vue?vue&type=script&lang=js"
export * from "./ClassicButton.vue?vue&type=script&lang=js"

import "./ClassicButton.vue?vue&type=style&index=0&id=f124aaac&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f124aaac"]])

export default __exports__